import React from 'react'

import { BlackButton as ScheduleButton } from 'components/styles'

export const Schedule = (): JSX.Element => {
  return (
    <ScheduleButton
      forwardedAs='a'
      as='a'
      href='https://www.jinglejam.co.uk/'
      size='medium'
      target='_blank'
      rel='noopener noreferrer'
    >
      VIEW THE FULL SCHEDULE
    </ScheduleButton>
  )
}
